export * from './customer/customer.component';
export * from './invoice/invoice.component';
export * from './quote/quote.component';
export * from './pack/pack.component';
export * from './postits/postits.component';
export * from './bike/bike.component';
export * from './statistic/statistic.component';
export * from './marketing/marketing.component';
export * from './bikes/bikes.component';
export * from './oneBike/oneBike.component';
export * from './tasks/tasks.component';
export * from './notPaid/notPaid.component';
export * from './export/export.component';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/index.ts